import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart, X } from 'lucide-react';
import './LoginPromptModal.css';

interface LoginPromptModalProps {
  onClose: () => void;
}

const LoginPromptModal: React.FC<LoginPromptModalProps> = ({ onClose }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    const currentPath = window.location.pathname + window.location.search + window.location.hash;
    navigate(`/login?redirect=${encodeURIComponent(currentPath)}`);
  };

  const handleSignUp = () => {
    const currentPath = window.location.pathname + window.location.search + window.location.hash;
    navigate(`/signup?redirect=${encodeURIComponent(currentPath)}`);
  };

  return (
    <div className="lpm-prompt-overlay" onClick={onClose}>
      <div className="lpm-prompt-card" onClick={e => e.stopPropagation()}>
        <button className="lpm-prompt-close" onClick={onClose} aria-label="Close">
          <X size={20} />
        </button>
        <div className="lpm-prompt-icon">
          <ShoppingCart size={32} />
        </div>
        <h3 className="lpm-prompt-title">Login Required</h3>
        <p className="lpm-prompt-text">
          You need an account to add items to your cart. Log in to continue ordering, or sign up — it only takes a minute.
        </p>
        <div className="lpm-prompt-actions">
          <button className="lpm-prompt-btn lpm-prompt-btn--primary" onClick={handleLogin}>
            Log In
          </button>
          <button className="lpm-prompt-btn lpm-prompt-btn--ghost" onClick={handleSignUp}>
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPromptModal;
